<div class="container-fluid">
    <!-- Page-Title -->
    <!-- end page title end breadcrumb -->
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="mb-3 d-flex align-items-center justify-content-between"><h4 class="mb-2 fw-bolder">Customer Master</h4>
                    <div class="mb-2">
                        <input type="text" placeholder="Search user by name" class="form-control mb-3" [(ngModel)]="searchText" (input)="onSearch()">
                    </div></div>
                    
                    <div class="table-responsive" style="max-height: 500px; overflow-y: auto;">
                        <table class="table mb-0 table-centered">
                            <thead>
                                <tr>
                                    <th (click)="sortColumn('userName')">Name<span class="datatable-icon-sort-unset sort-btn"></span></th>
                                    <th (click)="sortColumn('email')">Email<span class="datatable-icon-sort-unset sort-btn"></span></th>
                                    <th (click)="sortColumn('phone')">Phone<span class="datatable-icon-sort-unset sort-btn"></span></th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            
                            <!-- Add *ngFor loop for displaying user data -->
                            <tbody>
                                <tr *ngFor="let user of displayedUsers">
                                    <td>{{user.userName}}</td>
                                    <td>{{user.email}}</td>
                                    <td>{{user.phone}}</td>
                                    <!-- Add other user data here -->
                                    <td class="text-end">
                                        <!-- Add action buttons here -->
                                    </td>
                                </tr>
                            </tbody>
                        </table><!--end /table-->
                    </div><!--end /tableresponsive-->
                    <div class="datatable-footer-inner selected-count d-flex justify-content-between">
                        <!-- Display total entries on the left side in bold -->
                        <div class="page-count mt-3 ng-star-inserted">
                            <span class="font-weight-bold">{{ displayedUsers.length }} of {{ totalItems }} total</span> 
                        </div>
                    
                        <!-- Pagination controls on the right side -->
                        <div class="pagination mt-3 d-flex justify-content-center">
                            <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
                                <i class="feather icon-chevrons-left"></i>
                            </a>
                            <a *ngFor="let page of getPages()" class="pagination-circle" [class.active]="currentPage === page" (click)="onPageChange(page)">{{ page }}</a>
                            <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" [ngClass]="{'disabled': currentPage === mathLib.ceil(totalItems / itemsPerPage)}">
                                <i class="feather icon-chevrons-right "></i>
                            </a>
                        </div>
                        
                        
                        
                        
                    </div>
                </div><!--end card-body-->
            </div><!--end card-->
        </div> <!-- end col -->
    </div> <!-- end row -->
    
</div><!-- container -->